import React from "react";
import PropTypes from "prop-types";
import { Button } from "@learningblocks/shared-components";

export function AddNotes(props) {
  const [value, setValue] = React.useState("");

  const onChange = (event) => setValue(event.target.value);

  const onSubmit = () => {
    value && props.addNote(value);
    props.close();
  };

  return (
    <div className="step_btm_addNotes">
      <p className="step_btm_addNotes_title">Observations:</p>
      <textarea
        className="step_btm_addNotes_input"
        placeholder="Add Observations"
        onChange={onChange}
        value={value}
      />
      <div className="step_btm_addNotes_buttons">
        <Button type="secondary" onClick={props.close}>
          Cancel
        </Button>
        <Button onClick={onSubmit}>Save Note</Button>
      </div>
    </div>
  );
}

AddNotes.propTypes = {
  /**
   * Function to add note to list
   */
  addNote: PropTypes.func,
  /**
   * Function to close NoteListView
   */
  close: PropTypes.func,
};

AddNotes.defaultProps = {
  notes: [],
};
